var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWorkflows(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 21,
    viewBox: "0 0 23 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1 6.5V5.9H10.5H9.1V1.1H13.9V5.9H12.5H11.9V6.5V9.5V10.1H12.5H18.5C19.2786 10.1 19.9 10.7214 19.9 11.5V14.5V15.1H20.5H21.9V19.9H17.1V15.1H18.5H19.1V14.5V11.5V10.9H18.5H12.5H11.9V11.5V14.5V15.1H12.5H13.9V19.9H9.1V15.1H10.5H11.1V14.5V11.5V10.9H10.5H4.5H3.9V11.5V14.5V15.1H4.5H5.9V19.9H1.1V15.1H2.5H3.1V14.5V11.5C3.1 10.7214 3.72137 10.1 4.5 10.1H10.5H11.1V9.5V6.5Z",
    stroke: "currentColor",
    strokeWidth: 1.2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkflows);
export default __webpack_public_path__ + "static/media/workflows.b120af54c58e8d675a775e99a5ec8254.svg";
export { ForwardRef as ReactComponent };